import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'Context';
import { Pathname } from 'Routes';

/**
 * useLogout — the core sign-out used by settings / account.
 *
 * Clears the auth token + verified flag, flips sign-in state, and returns to the
 * sign-in screen. (The header's own logout additionally flushes in-flight upload
 * drafts and redux caches; those are header-scoped and not needed for a plain
 * sign-out from settings.)
 */
export const useLogout = () => {
  const { removeToken, setUserSignInStatus, removeEmailVerified, setPreferredEmail } = useContext(AuthContext);
  const navigate = useNavigate();

  return () => {
    try { removeToken(); } catch (e) { /* noop */ }
    try { setUserSignInStatus(false); } catch (e) { /* noop */ }
    try { removeEmailVerified(); } catch (e) { /* noop */ }
    try { setPreferredEmail(''); } catch (e) { /* noop */ }
    navigate(Pathname.authentication.newsignIn);
  };
};
